/*** IMPORTS FROM imports-loader ***/
var define = false;

const loadDropdowns = () => {
    const body = document.body
    const triggers = document.querySelectorAll('[data-dropdown]')

    for (let i = 0; i < triggers.length; i++) {
        const button = triggers[i]
        const menu = button.parentElement.querySelector(button.dataset.dropdown)

        if (menu) {
            button.addEventListener('click', event => {
                event.preventDefault()
                const parent = button.parentElement

                if (!parent.classList.contains('active')) {
                    parent.classList.add('active')

                    setTimeout(() => {
                        body.addEventListener('click', function onBodyClick (event) {
                            if (menu.contains(event.target)) return
                            parent.classList.remove('active')
                            body.removeEventListener('click', onBodyClick)
                        })
                    })
                }
            })
        }
    }
}

export default loadDropdowns




// WEBPACK FOOTER //
// ./js/dropdowns.js